import { useMemo } from 'react';

import type { SearchClient } from 'algoliasearch';
import TypesenseInstantsearchAdapter from 'typesense-instantsearch-adapter';

import { INSTANT_SEARCH_CACHE_SECONDS, INSTANT_SEARCH_FACET_BY } from 'src/app/pages/search/shared/consts';

import { useInstantSearchIndexName } from '../useInstantSearchIndexName';

import { useTypesenseConfig } from './useTypesenseConfig';

type Result = ModelHookResult<{
	searchClient: SearchClient;
	typesenseClient: TypesenseInstantsearchAdapter['typesenseClient'];
}>;

export function useSearchClient(): Result {
	const config = useTypesenseConfig();

	const {
		data: { instantSearchPreset },
	} = useInstantSearchIndexName();

	const instantSearchTypesense = useMemo(() => {
		return new TypesenseInstantsearchAdapter({
			server: {
				...config,
				cacheSearchResultsForSeconds: INSTANT_SEARCH_CACHE_SECONDS,
			},
			additionalSearchParameters: {
				preset: instantSearchPreset,
				facet_by: INSTANT_SEARCH_FACET_BY,
			},
		});
	}, [config, instantSearchPreset]);

	return {
		data: {
			searchClient: instantSearchTypesense.searchClient as SearchClient,
			typesenseClient: instantSearchTypesense.typesenseClient,
		},
	};
}
